import { UrlWs } from "./Global";

export function scrollId(id, offset = 100) {
  var element = document.getElementById(id);
  var headerOffset = offset;
  var elementPosition = element.getBoundingClientRect().top;
  var offsetPosition = elementPosition + window.pageYOffset - headerOffset;
  window.scrollTo({
    top: offsetPosition,
    behavior: "smooth",
  });
}

export function hoy() {
  var today = new Date();
  var dd = String(today.getDate()).padStart(2, "0");
  var mm = String(today.getMonth() + 1).padStart(2, "0");
  var yyyy = today.getFullYear();
  return dd + "-" + mm + "-" + yyyy;
}

export function ahora() {
  var today = new Date();
  var hh = String(today.getHours()).padStart(2, "0");
  var mm = String(today.getMinutes()).padStart(2, "0");
  return hh + ":" + mm;
}

export function fechaJava(){
  var today = new Date();
  var dd = String(today.getDate()).padStart(2, "0");
  var mm = String(today.getMonth() + 1).padStart(2, "0");
  var yyyy = today.getFullYear();

  var hh = String(today.getHours()).padStart(2, "0");
  var min = String(today.getMinutes()).padStart(2, "0");

  return `${yyyy}-${mm}-${dd}T${hh}:${min}:00`;
}

export async function archivoBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

export function fechaHumana(textoFecha, hora = false) {
  try {
    let fecha;
    if (typeof textoFecha == "string") {
      fecha = new Date(textoFecha);
    } else {
      fecha = textoFecha;
    }

    var userTimezoneOffset = fecha.getTimezoneOffset() * 60000;
    fecha = new Date(fecha.getTime() + userTimezoneOffset);

    let año = new Intl.DateTimeFormat("es", { year: "numeric" }).format(fecha);
    let mes = new Intl.DateTimeFormat("es", { month: "2-digit" }).format(fecha);
    let dia = new Intl.DateTimeFormat("es", { day: "2-digit" }).format(fecha);

    if (hora) {
      let hora = new Intl.DateTimeFormat("es", { hour: "2-digit" }).format(
        fecha
      );
      let minuto = new Intl.DateTimeFormat("es", { minute: "2-digit" }).format(
        fecha
      );
      return `${dia}-${mes}-${año} ${hora}:${minuto}`;
    } else {
      return `${dia}-${mes}-${año}`;
    }
  } catch (error) {
    console.error("Fecha mal ", textoFecha);
    return hoy();
  }
}

export function fechaInput(textoFecha, hora = false) {
  try {
    let fecha;
    if (typeof textoFecha == "string") {
      fecha = new Date(textoFecha);
    } else {
      fecha = textoFecha;
    }

    var userTimezoneOffset = fecha.getTimezoneOffset() * 60000;
    fecha = new Date(fecha.getTime() + userTimezoneOffset);

    let año = new Intl.DateTimeFormat("es", { year: "numeric" }).format(fecha);
    let mes = new Intl.DateTimeFormat("es", { month: "2-digit" }).format(fecha);
    let dia = new Intl.DateTimeFormat("es", { day: "2-digit" }).format(fecha);

    if (hora) {
      let hora = new Intl.DateTimeFormat("es", { hour: "2-digit" }).format(
        fecha
      );
      let minuto = new Intl.DateTimeFormat("es", { minute: "2-digit" }).format(
        fecha
      );
      return `${año}-${mes}-${dia} ${hora}:${minuto}`;
    } else {
      return `${año}-${mes}-${dia}`;
    }
  } catch (error) {
    console.error("Fecha mal ", textoFecha);
    return hoy();
  }
}

export function fechaServicio(textoFecha) {
  return textoFecha.split("-").reverse().join("-");
}

export function moneda(valor = 0) {
  return valor.toLocaleString("es-CL", {
    style: "currency",
    currency: "CLP",
  });
}

export function nombreDireccion(id_direccion) {
  if (id_direccion == null || id_direccion == "") {
    return "";
  }
  const url = UrlWs + "/municipal-management/list";
  return fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then(async (response) => {
      if (response.status == 400) {
        return "No se encontró la dirección";
      } else {
        return response.json();
      }
    })
    .then(async (response) => {
      if (Array.isArray(response)) {
        const direccionEncontrada = response.find(
          (d) => d.id_Dmunicipal == id_direccion
        );
        return direccionEncontrada.nameDmunicipal;
      } else {
        return "No se encontró la dirección";
      }
    });
}

export function version(block = true) {
  return (
    <p className={block ? "d-block text-center" : "d-inline-block text-center"}>
      <strong className="text-muted ms-4 text-center">Versión 1.2.3</strong>
    </p>
  );
}

export function buscarDatos(busqueda, datos) {
  const datosBuscar = datos.map(({ ...obj }, index) => [
    index,
    Object.values(obj).flat(),
  ]);
  busqueda = busqueda.toLowerCase();
  const datosEncontrados = datosBuscar
    .filter(([, strings]) => {
      return strings.some(
        (string) =>
          string != null && string.toString().toLowerCase().includes(busqueda)
      );
    })
    .map(([obj]) => obj);
  return datosEncontrados.map((item) => datos[item]);
}

export function ordenarDatos(campo, orden, datos) {
  console.log("ordenarDatos ", campo, orden);
  function compare(a, b) {
    let campoA, campoB;

    if (isNaN(a[campo])) {
      console.log("ISNAN");
      campoA = a[campo].trim().toLowerCase();
    } else {
      campoA = a[campo];
    }
    if (isNaN(b[campo])) {
      console.log("ISNAN");
      campoB = b[campo].trim().toLowerCase();
    } else {
      campoB = b[campo];
    }

    if (isNaN(campoA) && !isNaN(campoB)) {
      campoB = campoB.toString().trim().toLowerCase();
    }

    if (isNaN(campoB) && !isNaN(campoA)) {
      campoA = campoA.toString().trim().toLowerCase();
    }
    console.log("campoA ", campoA);
    console.log("campoB ", campoB);
    if (orden == "asc") {
      if (campoA < campoB) {
        return -1;
      }
      if (campoA > campoB) {
        return 1;
      }
    } else {
      if (campoA > campoB) {
        return -1;
      }
      if (campoA < campoB) {
        return 1;
      }
    }
    return 0;
  }
  datos.sort(compare);
  return datos;
}
